import riot from 'riot';
import { MapStore } from './store';
import { getCookieValue } from 'lib/util';

import store from './store_instance';
window.store = store;

let MapCollabClient;
if (window.pageSettings.disableWebsocket || !getCookieValue('visitor')) {
  // no-op the websocket if it's a part of the page settings (a la embedded
  // maps) or we can't track the client (as we use a cookie set on the client
  // as part of our bookkeeping on the server).
  MapCollabClient = require('lib/map_collab_client_noop');
} else {
  MapCollabClient = require('lib/map_collab_client');
}

import { MapOperation } from './operation';

const people = {
  owner: window.map_owner,
  currentUser: window.user,
  collaborators: window.map_collaborators,
};
const config = window.config;

const sender = new MapCollabClient({ access: store.access, config });
const operation = new MapOperation({ sender, store });
operation.previousSequence = window.map_operation_sequence;
window.operation = operation;

import 'tags/node-eyeball';
import 'tags/perspectives-banner';
import 'tags/perspectives-banner-item';
import 'tags/dummy-input';
import 'tags/sidebar';
import 'tags/bulk-actions-menu';
import 'tags/raw';
import 'tags/user-settings';
import 'tags/external-link-popover';
import 'tags/user-guide';
import 'tags/user-guide-item';
import 'tags/shortcuts-help';
import 'tags/autocomplete';
import 'tags/color-picker';
import 'tags/selection-area';
import 'tags/link';
import 'tags/links';
import 'tags/map-status';
import 'tags/map-menu';
import 'tags/export-menu';
import 'tags/node-tools';
import 'tags/child-nodes';
import 'tags/nodes';
import 'tags/node';
import 'tags/presence';
import 'tags/app';
import 'tags/app-header';
import 'tags/rapid-card-creator';
import 'tags/app-footer';
import 'tags/node-menu';
import 'tags/link-menu';
import 'tags/modal-share';
import 'tags/modal-image';
import 'tags/modal-intro';
import 'tags/modal-search';
import 'tags/modal-import';
import 'tags/modal-extensions';
import 'tags/search-item';
import 'tags/lightbox';
import 'tags/tools-sidebar';
import 'tags/node-alignment-panel';
import 'tags/node-layout-menu';
import 'tags/map-alert';
import 'tags/node-perspective-dots';
import 'tags/node-perspective-dot';
import 'tags/node-perspective-annotation';
import 'tags/node-perspective-annotations';
import 'tags/perspectives-listing';
import 'tags/perspectives-listing-item';
import 'tags/node-perspectives-panel-item';
import 'tags/perspectives-listing-item-tool-menu';
import 'tags/node-perspectives-panel';
import 'tags/new-perspective-autocomplete';
import 'tags/perspective-settings-menu';
import 'tags/perspective-settings-text-menu';
import 'tags/perspective-annotation-popover';
import 'tags/collapsed-card-adoption-popover';
import 'tags/popover';
import 'tags/undo-banner';
import 'tags/waypoints-tab';
import 'tags/waypoints-tab-menu';
import 'tags/waypoints-tab-item-menu';
import 'tags/waypoint-selector';
import 'tags/waypoint-indication-box';
import 'tags/connection-error-banners';
import 'tags/presentation-controls';
import 'tags/zoom-tools';
import 'tags/right-click-menu';
import 'tags/link-direction-menu';
import 'tags/image-size-menu';
import 'tags/node-image-menu';
import 'tags/menu/edit-share-user-access-menu';
import 'tags/menu/toolbar-view-more-menu';
import 'tags/menu/region-shape-menu';
import 'tags/menu/items/menu-item-delete';
import 'tags/menu/items/menu-item-duplicate';
import 'tags/menu/items/menu-item-create-relationship-card';
import 'tags/menu/items/menu-item-detach-relationship-card';
import 'tags/menu/items/menu-item-detach-part';
import 'tags/menu/items/menu-item-ungroup-system';
import 'tags/menu/items/menu-item-pop-parts';
import 'tags/menu/items/menu-item-layout';
import 'tags/menu/items/menu-item-images';
import 'tags/menu/items/menu-item-arrange';
import 'tags/menu/items/menu-item-group-selection';
import 'tags/menu/items/menu-item-card-style';
import 'tags/menu/items/menu-item-relationship-style';
import 'tags/menu/items/menu-item-link-direction';
import 'tags/menu/items/menu-item-create-waypoint';
import 'tags/menu/items/menu-item-perspectives';
import 'tags/menu/items/menu-item-export';
import 'tags/menu/items/menu-item-link-to-selection';
import 'tags/menu/items/menu-item-straighten-line';
import 'tags/menu/items/menu-item-attribute-editor';
import 'tags/menu/items/menu-item-edit-attribute';
import 'tags/menu/items/menu-item-remove-attribute';
import 'tags/menu/items/menu-item-select-all';
import 'tags/menu/items/menu-item-edit-region-color';
import 'tags/menu/items/menu-item-edit-region-title';
import 'tags/menu/items/menu-item-edit-region-shape';
import 'tags/menu/items/menu-item-delete-region';
import 'tags/menu/items/menu-item-create-region-from-selection';
import 'tags/menu/items/menu-item-create-region';
import 'tags/menu/items/menu-item-duplicate-region';
import 'tags/menu/items/menu-item-create-card';
import 'tags/menu/items/menu-item-create-line';
import 'tags/menu/items/menu-item-paste';
import 'tags/menu/items/menu-item-settings';
import 'tags/menu/items/menu-item-add-part';
import 'tags/menu/items/menu-item-add-summary';
import 'tags/menu/items/menu-item-add-comment';
import 'tags/menu/buttons/menu-button-layout';
import 'tags/menu/buttons/menu-button-delete';
import 'tags/menu/buttons/menu-button-detach-parts';
import 'tags/menu/buttons/menu-button-detach-from-relationship';
import 'tags/menu/buttons/menu-button-create-relationship-card';
import 'tags/menu/buttons/menu-button-relationship-style';
import 'tags/menu/buttons/menu-button-drawing-style';
import 'tags/menu/buttons/menu-button-link-direction';
import 'tags/menu/buttons/menu-button-straighten-line';
import 'tags/menu/buttons/menu-button-perspectives';
import 'tags/menu/buttons/menu-button-create-relationship';
import 'tags/menu/buttons/menu-button-alignment';
import 'tags/menu/buttons/menu-button-group';
import 'tags/menu/buttons/menu-button-add-part';
import 'tags/menu/buttons/menu-button-duplicate-selection';
import 'tags/menu/buttons/menu-button-add-image';
import 'tags/menu/buttons/menu-button-add-summary';
import 'tags/menu/buttons/menu-button-pop-parts';
import 'tags/menu/buttons/menu-button-style-card';
import 'tags/menu/buttons/menu-button-attribute-editor';
import 'tags/menu/buttons/menu-button-add-comment';
import 'tags/node-attributes';
import 'tags/node-attribute-editor';
import 'tags/attributes-tab';
import 'tags/node-attribute-menu';
import 'tags/modal-checkout';
import 'tags/modal-checkout-confirmation';
import 'tags/node-limit-upsell-banner';
import 'tags/site-previewer';
import 'tags/site-previewer-item';
import 'tags/menu/site-previewer-menu';
import 'tags/region';
import 'tags/regions';
import 'tags/region-menu';
import 'tags/text-toolbar.html';
import 'tags/menu/buttons/menu-button-delete-region';
import 'tags/menu/buttons/menu-button-edit-region-color';
import 'tags/menu/buttons/menu-button-edit-region-shape';
import 'tags/menu/buttons/menu-button-edit-region-title';
import 'tags/menu/buttons/menu-button-select-all-in-region';
import 'tags/modal-templates';
import 'tags/modal-template';
import 'tags/line-creation-tool';
import 'tags/undo-redo';
import 'tags/creation-tools';
import 'tags/creation-tools-tab';
import 'tags/zen-mode';
import 'tags/modal-import/import-preview-card';
import 'tags/modal-import/import-preview-card-parts';
import 'tags/modal-share/autocomplete-contacts';
import 'tags/modal-share/panel-link';
import 'tags/modal-share/panel-invite';
import 'tags/modal-share/panel-presentation';
import 'tags/modal-share/panel-embed';
import 'tags/modal-extensions/add-on-panel';
import 'tags/collaborator-activity-banner';
import 'tags/region-creation-tool';
import 'tags/presence-cursors';
import 'tags/notifications';
import 'tags/gallery';
import 'tags/loading';
import 'tags/modal-sign-up';
import 'tags/onboarding-popup';
import 'tags/node-align-content-menu';
import 'tags/menu/items/menu-item-link-curvature';
import 'tags/menu/buttons/menu-button-link-curvature';
import 'tags/comments/comments-layer';
import 'tags/comments/comment';
import 'tags/comments/canvas-comment';
import 'tags/comments/comment-replies';
import 'tags/comments/new-comment-input';
import 'tags/comments/new-comment-panel';
import 'tags/comments/comments-container';
import 'tags/comments/comments-sidebar';
import 'tags/comments/comment-menu';
import 'tags/comments/comment-reaction-menu';
import 'tags/floating-tooltip';
import 'tags/multi-selection-indicator-box';
import 'tags/link-endpoint';
import 'tags/workspace-avatar';
import '../../shared/tags/switch';
import 'tags/menu/accept-request-access-menu';
import '../../shared/tags/modal-invite';
import '../../shared/tags/app-notification';
import 'tags/header-save-indicator';
import 'tags/navigation-switcher';
import 'tags/sketchpad';
import 'tags/drawings';
import 'tags/drawing';
import 'tags/drawing-menu';

store.load(JSON.parse(unescape(window.escaped_map_data)));

riot.settings.autoUpdate = false;
requestAnimationFrame(() => riot.mount('app', { store, operation, people, config }));

export default store;



// WEBPACK FOOTER //
// ./starling/src/main.js